import { render, staticRenderFns } from "./DocImport.vue?vue&type=template&id=4d468e56&scoped=true"
import script from "./DocImport.vue?vue&type=script&lang=js"
export * from "./DocImport.vue?vue&type=script&lang=js"
import style0 from "./DocImport.vue?vue&type=style&index=0&id=4d468e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d468e56",
  null
  
)

export default component.exports